const returnUrlKey = "url"

export const appendReturnUrl = (currentUrl: URL, returnUrl: URL) => {
  const url = new URL(currentUrl)
  url.searchParams.append(returnUrlKey, returnUrl.toString())
  return url
}

/**
 * ログイン時やユーザー登録完了時の遷移先をURLパラメータから取得します。
 */
export const resolveSafeReturnUrl = () => {
  if (typeof window === "undefined") {
    return null
  }
  const unsafeUrl = new URLSearchParams(window.location.search).get(returnUrlKey)
  if (unsafeUrl !== null) {
    const returnUrl = new URL(unsafeUrl, window.location.origin)
    // オープンリダイレクト攻撃の対策
    if (returnUrl.origin === window.location.origin) {
      return returnUrl
    }
  }

  return null
}

export const redirectToLogin = () => {
  // iframe内から呼ばれることを考慮してtopを指定してます。
  const win = window.top ?? window
  const redirectUrl = appendReturnUrl(new URL("/kiban/csComLogin.do", win.location.origin), new URL(win.location.href))

  win.location.replace(redirectUrl)
}
